"use client";

import type { PropsWithChildren } from "react";
import { motion } from "framer-motion";
import { usePathname } from "next/navigation";
import { isLegalPagePath } from "@/lib/legal-pages";

interface CSSStaggerItemProps extends PropsWithChildren {
  className?: string;
}

export function CSSStaggerItem({ children, className }: CSSStaggerItemProps) {
  const pathname = usePathname();
  if (isLegalPagePath(pathname)) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.5, ease: "easeOut" },
        },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
